export default "__VITE_ASSET__DccDG9pA__"